import { buildHeadersWithWidgetToken } from '@elfsight/lib-utils';
import { useQuery } from '@tanstack/react-query';
import { useSettings } from '@wu/widget-core';
import { apiBaseUrl } from '../constants/api-base-url';

export interface GeocodingSearch {
  id: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
  name: string;
  address: string;
}

export type GeocodingResponse = {
  payload: GeocodingSearch[];
  code: number;
  message: string;
};

const ENDPOINT_PATH = `places/geocoding/v2/search`;

export function useGeocodingSearch({
  query,
  enabled
}: {
  query: string;
  enabled: boolean;
}) {
  const { widgetToken } = useSettings();

  return useQuery<GeocodingResponse, string, GeocodingSearch[]>({
    queryKey: [ENDPOINT_PATH, query, widgetToken],
    queryFn: async () => {
      if (!widgetToken) {
        console.error('Widget token is not set.');
        return null;
      }

      const url = new URL(`${apiBaseUrl}${ENDPOINT_PATH}`);
      url.searchParams.set('location', query);
      url.searchParams.set('locale', window.navigator.language.toLowerCase());

      const response = await fetch(url, {
        headers: buildHeadersWithWidgetToken(widgetToken)
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      return data.payload;
    },
    enabled: Boolean(enabled && widgetToken),
    retry: 0
  });
}
